var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-none"},[_c('input',{ref:"file",attrs:{"type":"file"},on:{"change":_vm.upload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }